import { FC, ReactNode } from 'react';
import { IconChevronUp, IconChevronDown } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

interface StatsCardProps {
  title: string;
  value: string | number;
  trend?: {
    value: number;
    label: string;
    isPositive?: boolean;
  };
  icon?: ReactNode;
  linkTo?: string;
  subtitle?: string;
  className?: string;
}

const StatsCard: FC<StatsCardProps> = ({
  title,
  value,
  trend,
  icon,
  linkTo,
  subtitle,
  className = '',
}) => {
  const content = (
    <div
      className={`rounded-lg bg-white p-6 shadow-sm transition-shadow hover:shadow-md ${className}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="text-sm font-medium text-gray-500">{title}</div>
          <div className="mt-2 flex items-baseline gap-2">
            <div className="text-3xl font-bold text-gray-900">{value}</div>
            {trend && (
              <div
                className={`flex items-center gap-1 text-sm font-medium ${
                  trend.isPositive === true
                    ? 'text-green-600'
                    : trend.isPositive === false
                      ? 'text-red-600'
                      : 'text-gray-600'
                }`}
              >
                {trend.isPositive === true ? (
                  <IconChevronUp className="h-4 w-4" />
                ) : trend.isPositive === false ? (
                  <IconChevronDown className="h-4 w-4" />
                ) : null}
                <span>{Math.abs(trend.value)}%</span>
              </div>
            )}
          </div>
          {subtitle && (
            <div className="mt-1 text-xs text-gray-500">{subtitle}</div>
          )}
          {trend?.label && (
            <div className="mt-1 text-xs text-gray-500">{trend.label}</div>
          )}
        </div>
        {icon && (
          <div className="ml-4 flex h-12 w-12 items-center justify-center rounded-lg bg-gray-100 text-gray-600">
            {icon}
          </div>
        )}
      </div>
    </div>
  );

  if (linkTo) {
    return (
      <Link
        to={linkTo}
        className="block"
        aria-label={`${title}: ${value}. ${subtitle || ''} ${trend?.label || ''}`.trim()}
      >
        {content}
      </Link>
    );
  }

  return content;
};

export default StatsCard;
